import styled, { css } from 'styled-components'
import { palette } from '../../../theme/palette'

export const ImageMessageContainer = styled.div<{ hasMessageFromBot: boolean }>`
  margin: 0 31px 10px 0;
  padding-left: ${props => props.hasMessageFromBot ? 15 : 56}px;
  
  ${props => props.hasMessageFromBot && css`
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: flex-start;
    white-space: pre-wrap;
  `}
`

export const TemplateImageButton = styled.button`
  border: none;
  border-radius: 14px;
  
  &:focus-visible {
    outline: 2px solid ${palette.mainBlue};
  }
`

export const TemplateImage = styled.img`
  max-width: 290px;
  width: 100%;
  animation: .5s messageImageAnimation;
  cursor: zoom-in;
  filter: drop-shadow(0px 1px 0px rgba(0, 0, 0, 0.04));
  border-radius: inherit;
  display: block;
`
